import { takeLatest, put, take } from 'redux-saga/effects';

import * as UtilsActions from './actions';
import { UtilsTypes } from './types';

/**
 * @param payload
 * Dispatches a chain of actions in sequence. An action is dispatched only when the
 * previous action is completed with a success or failure(generating an "await" effect).
 */
function* dispatchActionsChain({
  payload,
}: ReturnType<typeof UtilsActions.dispatchActionsChainRequest>) {
  try {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < payload.length; i++) {
      const { action, typeSuccess, typeFailure } = payload[i];
      yield put(action(payload[i].payload));
      yield take([typeSuccess, typeFailure]); // "await" -> action success or action failure
    }
    yield put(UtilsActions.dispatchActionsChainSuccess());
  } catch (error) {
    console.error('utilsActions - dispatchActionsChain - error', error);
    yield put(UtilsActions.dispatchActionsChainFailure());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const utilsSagas = [
  takeLatest(UtilsTypes.DISPATCH_ACTIONS_CHAIN_REQUEST, dispatchActionsChain),
];
